import * as React from "react";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";

export default function CalendarCard({ onDateChange, selectedDate }) {
    const [value, setValue] = React.useState(dayjs(selectedDate || new Date())); // ✅ initialize date with selected date or today

    const handleDateChange = (newValue) => {
        setValue(newValue);
        if (onDateChange) {
            onDateChange(newValue.toDate()); // Convert dayjs to Date object
        }
    };

    // Update value when selectedDate prop changes
    React.useEffect(() => {
        if (selectedDate) {
            setValue(dayjs(selectedDate));
        }
    }, [selectedDate]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateCalendar
                value={value}
                onChange={handleDateChange} // ✅ update date on selection and trigger API
                sx={{
                    width: "100%",
                    margin: "auto",
                    overflow: "hidden",
                    "& .MuiPickersCalendarHeader-root": {
                        display: "flex",
                        justifyContent: "center",
                    },
                    "& .MuiPickersSlideTransition-root": {
                        minHeight: "400px",
                    },
                    "& .MuiDayCalendar-header, & .MuiDayCalendar-weekContainer": {
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        justifyContent: "space-between",
                    },
                    "& .MuiDayCalendar-weekDayLabel": {
                        fontSize: "14px",
                        textAlign: "center",
                    },
                    "& .MuiPickersDay-root": {
                        overflow: "hidden",
                        width: "30px",
                        height: "30px",
                        fontSize: "14px",
                        margin: "4px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    },
                }}
            />
        </LocalizationProvider>
    );
}
